// extracted by mini-css-extract-plugin
export var number_stepper_center_side = "index-module--number_stepper_center_side--fe277";
export var number_stepper_con = "index-module--number_stepper_con--08280";
export var number_stepper_left_side = "index-module--number_stepper_left_side--a1af8";
export var number_stepper_right_side = "index-module--number_stepper_right_side--2bdd3";